import { render } from "./patient_list.vue?vue&type=template&id=5902c28c&scoped=true"
import script from "./patient_list.vue?vue&type=script&lang=js"
export * from "./patient_list.vue?vue&type=script&lang=js"

import "./patient_list.vue?vue&type=style&index=0&id=5902c28c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5902c28c"]])

export default __exports__